/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_Hide_DefaultInputs */

const cs_pipelines_hide_default = /** @type {(inputs: Pipelines_Hide_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skrýt výchozí nástěnku`)
};

const en_pipelines_hide_default = /** @type {(inputs: Pipelines_Hide_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hide default board`)
};

/**
* | output |
* | --- |
* | "Hide default board" |
*
* @param {Pipelines_Hide_DefaultInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_hide_default = /** @type {((inputs?: Pipelines_Hide_DefaultInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_Hide_DefaultInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_hide_default(inputs)
	return cs_pipelines_hide_default(inputs)
});